var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA3M(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7598_88296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8166 20.9104L5.92357 21.0684L5.92597 21.0677L15.3902 13.095L13.9783 12.7488C8.27202 11.35 6.73095 7.85046 6.64245 4.64886C11.9435 10.1782 15.9903 11.8413 16.1702 11.9141L16.6007 12.0888L16.9441 11.7734C19.5376 9.40407 17.8405 6.46241 16.433 4.58466L21.352 2.48966L21.3096 2.34317L13.9121 3.77868L14.6039 4.64033C16.5269 7.04036 17.4833 8.86127 16.2785 10.3369C15.0078 9.70519 11.1467 7.5147 6.53853 2.36524L5.44579 1.14335L5.25627 2.77276C4.62634 8.18625 7.10925 12.0535 12.271 13.7921L3.8166 20.9104Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7598_88296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.965,
    height: 19.2725,
    fill: "white",
    transform: "translate(-1.33594 3.10602) rotate(-16.1402)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3M);
export default __webpack_public_path__ + "static/media/A3M.f2712739653edaa4ef519603c627cceb.svg";
export { ForwardRef as ReactComponent };